@if (data$ | async) {
  <ion-content>
    <div class="bg-div">
      <div class="logo-main-div">
        <img class="offer-logo" src="../../../assets/icon/offer-logo.png" alt="offer-logo" />
      </div>
      <div class="text-section-1">
        <p class="win-big-text">{{ "fork1.win_big" | translate }}</p>
        <p class="play-text">{{ "fork1.Playto" | translate }}</p>
      </div>
      <div class="circle">
        <div class="circle-inner">
          <div class="for-inner-text">
            <p class="lines">10 {{ "fork1.Line(s)" | translate }} <br />{{ "fork1.For" | translate }}</p>
            <h1 class="prize-amount">{{currencySymbol}}{{currency}}</h1>
          </div>
        </div>
      </div>
      <div class="text-section-2">
        <p class="more-text" style="margin: 0" [innerHTML]="'fork1.more_chances' | translate"></p>
        <p class="more-text"> {{ "fork1.win_up" | translate }} <span>{{forkPrize}}</span> {{ "fork1.prizes" | translate }} </p>
      </div>
      <div class="trust-piolet">
        <img src="../../../assets/icon/Trustpilot Dark.png" alt="" />
      </div>
      <div class="play-div">
        <button class="play-btn" (click)="goToFreeReg4c()">{{ "fork1.Playto" | translate }}</button>
      </div>
      <div class="play-smart">
        <p>{{ "fork1.Smart-way" | translate }}</p>
      </div>
    </div>
    <div class="second-section">
      <h2 class="common-margin" [innerHTML]="'fork1.Or' | translate"></h2>
      <h4 class="common-margin join-friends" [innerHTML]="'fork1.Play' | translate"></h4>
    </div>
    <div class="create-btn-div">
      <button class="create-btn" [innerHTML]="'fork1.Create' | translate" (click)="goToStore()"></button>
    </div>
    <div class="decide-later-wraper">
      <!--
      Decide later removed
      <h1 (click)="backToTabs()">{{hints[5]}}</h1>
      -->
    </div>
  </ion-content>
} @else {
  <ion-skeleton-text animated slot="center" class="skeleton-one"></ion-skeleton-text>
  <ion-skeleton-text animated class="skeleton-two"></ion-skeleton-text>
  <ion-skeleton-text animated class="skeleton-three"></ion-skeleton-text>
  <ion-skeleton-text animated class="skeleton-four four-one"></ion-skeleton-text>
  <ion-skeleton-text animated class="skeleton-four four-two"></ion-skeleton-text>
  <ion-skeleton-text animated class="skeleton-four four-three"></ion-skeleton-text>
  <ion-skeleton-text animated class="skeleton-four four-four"></ion-skeleton-text>
  <ion-skeleton-text animated class="skeleton-five five-one"></ion-skeleton-text>
  <ion-skeleton-text animated class="skeleton-five five-two"></ion-skeleton-text>
  <ion-skeleton-text animated class="skeleton-six"></ion-skeleton-text>
  <ion-skeleton-text animated class="skeleton-seven"></ion-skeleton-text>
}

